/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `FormFieldLabelPosition*`'s.
 */
export type FormFieldLabelPosition = FormFieldLabelPositionLeft | FormFieldLabelPositionTop;

/**
 * The FormField label left position type.
 */
export type FormFieldLabelPositionLeft = typeof FORM_FIELD_LABEL_POSITION_LEFT;

/**
 * The FormField label top position type.
 */
export type FormFieldLabelPositionTop = typeof FORM_FIELD_LABEL_POSITION_TOP;

/**
 * The FormField label left position constant.
 */
export const FORM_FIELD_LABEL_POSITION_LEFT = `left`;

/**
 * The FormField label top position constant.
 */
export const FORM_FIELD_LABEL_POSITION_TOP = `top`;
